// English translation

const en = {
  "account.statement.open": "Open",
  "account.statement.close": "Close",
  "account.statement.expenses": "See Expenses",
  "account.statement.date": "Date",
  "account.statement.start_balance": "Start Balance",
  "account.statement.line": "Statement Line",
  "account.statement.line.amount": "Amount",
  "account.statement.line.statement": "Statement",
  "account.statement.line.date": "Date",
  "account.statement.line.number": "Number",
  "account.statement.line.party": "Party",
  "account.statement.open.msg_start":
    "Please, enter start balance for open account statement...",
  "account.statement.open.msg_success":
    "Estados de cuenta abiertos exitosamente!",
  "account.statement.open.msg_error": "Missing the terminal configuration!",
  "account.statement.close.msg_start":
    "Do you want close account statements for your terminal?",
  "account.statement.close.msg_success": "Account statements closed success!",
  "account.statement.close.msg_error": "Missing the terminal configuration!",
  "account.statement.create_uid": "Create User",
  "account.statement.tips": "See Tips",
  "account.statement.sale.delivery": "Deliveries",
  "account.statement.sale.tips": "Tips",
  "account.statement.sale.total": "Total",
  "account_statement.advanced.report": "Advanced Report",
  "account_statement.cash_up.report": "Cash Up Report",
  "sale_pos.expenses_daily.invoice_number": "Invoice number",
  "sale_pos.expenses_daily.description": "Description",
  "sale_pos.expenses_daily.amount": "Amount",
  "sale_pos.expenses_daily.party": "Provider",
  "sale_pos.expenses_daily.reference": "Reference",
  "sale_pos.expenses_daily": "Daily Expenses",
  "sale_pos.expenses_daily.statement": "Account Statement",
  "sale_pos.expenses_daily.create_uid": "Created by",
};

export default en;
